// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3NU3E","description":"PatientConsentPreview_description__1PN0v"};